export default __webpack_public_path__ + "static/media/ic-edit-copy.4f974312.svg";